export default __webpack_public_path__ + "static/media/花瓣2.dff85d57.svg";